import Modals from "components/modal";
import Content from "./activationContent";
import { useTranslation } from "react-i18next";
import { getUserData } from "containers/services/data.transformers";
import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { WebengageGeneralButtonEvent } from "containers/services/events.data";
import "./index.scss";

const Activation = ({ onClick, modalRef }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const { t } = useTranslation();
  const dscode = useSelector((state) => state?.fundReducer?.userFund?.ds_code);
  const prevMenu = useSelector((state) => state?.routerReducer?.prevMenu);


  const gertUser = async () => {
    const userData = await getUserData();
    setUser(userData);
  };

  useMemo(async () => {
    await gertUser();
  }, []);

  const renderTitle = () => {
    return user?.level === 0 || user?.level === 1
      ? t("onb.active-account")
      : t("onb.active-fund");
  };

  const onCancel = () => {
    location.pathname === "/bank/onboarding" && navigate(-1);
  };

  const onActivationClick = () => {
    onClick();
    const eventName =
      user?.level === 2 && dscode
        ? "fund-button-fund-onboarding-submit"
        : "button-account-activation";
    const attr = user?.level === 2 && dscode && { "Object Id": dscode };
    WebengageGeneralButtonEvent(eventName, prevMenu, "button", attr);
  };

  return (
    <Modals
      afterClose={() => onCancel()}
      title={renderTitle()}
      reference={modalRef}
      width="80%"
      className="max-w-md onb-activation-info-modal"
      footer={null}
    >
      <Content onClick={onActivationClick} user={user} />
    </Modals>
  );
};
export default Activation;
